import "../../styles/loader.css";

const Loader = () => {
  return <div className="loading-spinner"></div>;
};

export default Loader;